import { api } from '../configs/axiosConfigs';

export const getMostRecentAvmResults = async (propertyId: string) => {
  return await api.get(`/properties/${propertyId}/most-recent-avms`);
};
